module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('LoadingSpinner', {
    attrs: {
      "showContent": _vm.isReady && !_vm.isLoading,
      "size": 100
    }
  }, [(_vm.isError) ? _c('Infotext', {
    attrs: {
      "text": "Модуль отключен"
    }
  }) : [_c('Header', {
    attrs: {
      "name": _vm.name
    }
  }), (!_vm.isFormOpen) ? [_c('OpenForm', {
    attrs: {
      "mainText": "Нажмите + чтобы добавить новое достижение",
      "helpText": "Добавляйте достижения, чтобы отмечать их прогресс."
    },
    on: {
      "openForm": _vm.form
    }
  }), (_vm.studentsList.length) ? _c('NokoFilter', {
    attrs: {
      "competition": _vm.competition,
      "students": _vm.studentsList,
      "competitionIdProp": _vm.competitionId,
      "studentIdProp": _vm.studentId
    },
    on: {
      "competitionIdChange": _vm.competitionIdChange,
      "studentIdChange": _vm.studentIdChange
    }
  }) : _vm._e(), _c('Result', {
    attrs: {
      "result": _vm.resultForSelectedChild
    }
  })] : _vm._e(), _c('router-view', {
    on: {
      "form": _vm.form,
      "submitProgressForm": _vm.submitProgress,
      "submitCompetitionForm": _vm.submitCompetitionForm
    }
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15daf6e6","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/progress/Progress.vue
// module id = da5d393c3881f33913fe
// module chunks = 11